import { render, staticRenderFns } from "./GiftInfoModal.vue?vue&type=template&id=6be51eb2&scoped=true"
import script from "./GiftInfoModal.vue?vue&type=script&lang=ts"
export * from "./GiftInfoModal.vue?vue&type=script&lang=ts"
import style0 from "./GiftInfoModal.vue?vue&type=style&index=0&id=6be51eb2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be51eb2",
  null
  
)

export default component.exports